import {
  TRACTOR_DETAILS_STEP,
  TRACTOR_INTRO_STEP,
  TRACTOR_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Tractor";
import {
  TractorProductDetailsFormValues,
  TractorProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Tractor/tractorInterface";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { TractorType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Tractor";
import { Trafikkforsikringsavgift } from "Store/interfaces/Trafikkforsikringsavgift";
import { mapFormToInjuries } from "Store/priceCalculation/productMappers/common/injuriesMapper";

export interface TractorProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;

  tractorType: TractorType;
  model: string;
  modelYear: number;

  coverageAmount: number;
  insuranceHolderIsOwner: boolean;

  damageCountRecentYears: number;
  yearOfLastDamage?: number;

  trafikkforsikringsavgift?: Trafikkforsikringsavgift;
}

export const mapToCommerceTractor = (
  data: Record<string, any>,
): TractorProductBackend => {
  const tractorIntroData = data.formData[TRACTOR_INTRO_STEP.id];
  const tractorDetailsData: TractorProductDetailsFormValues =
    data.formData[TRACTOR_DETAILS_STEP.id];
  const tractorPriceData: TractorProductPriceFormValues =
    data.formData[TRACTOR_PRICE_STEP.id];

  return {
    name: INSURANCE_NAME_VALUE.TRACTOR,
    coverageGroup: data.coverage,

    tractorType: tractorIntroData.tractorType,
    modelYear: Number(tractorIntroData.firstRegistered),
    model: tractorIntroData.brandOrModel,

    coverageAmount: tractorDetailsData.coverageAmount,
    insuranceHolderIsOwner: true,

    ...mapFormToInjuries(
      tractorDetailsData.injuries,
      tractorDetailsData.injuryYear,
    ),

    trafikkforsikringsavgift: {
      monthlyAmount: tractorPriceData.tfaAmount.monthly,
      yearlyAmount: tractorPriceData.tfaAmount.yearly,
    },
  };
};
